import React from 'react'
import { Box, Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import RiskTradeChart from '../Charts/RiskTradeChart'
import ConcurrentChart from '../Charts/ConcurrentChart'
import LotsDayChart from '../Charts/LotsDayChart'
import LotsTradeChart from '../Charts/LotsTradeChart'

const TradesLots = ({
  LotsPerTrade,
  TradesLotsPerDay,
  ConcurrentTrades,
  RiskPerTrade,
}) => {
  const [value, setValue] = React.useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <div style={{ width: '100%' }} className="Container-p-20">
      <Box className="ContainerTab TradersLots" sx={{ width: '100%' }}>
        <TabContext value={value}>
          <Box
            className="mbb-30 SubTab "
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab
                className="ContainertabName"
                label="Risk per trade"
                value="1"
              />
              <Tab
                className="ContainertabName"
                label="Concurrent trades & Lots per day"
                value="2"
              />
              <Tab
                className="ContainertabName"
                label="Trades & Lots per day"
                value="3"
              />
              <Tab
                className="ContainertabName"
                label="Lots per trade"
                value="4"
              />
            </TabList>
          </Box>
          <TabPanel value="1">
            <RiskTradeChart data={RiskPerTrade && RiskPerTrade} />
          </TabPanel>
          <TabPanel value="2">
            <ConcurrentChart data={ConcurrentTrades && ConcurrentTrades} />
          </TabPanel>
          <TabPanel value="3">
            <LotsDayChart data={TradesLotsPerDay && TradesLotsPerDay} />
          </TabPanel>
          <TabPanel value="4">
            <LotsTradeChart data={LotsPerTrade && LotsPerTrade} />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  )
}

export default TradesLots
